export default __webpack_public_path__ + "assets/5.8db3428f.png";